export const setPasswordCheckCalcs = (calcs) => ({
    type: "SET_PASSWORD_CHECK_CALCS",
    calcs
});

export const setPasswordCheckFailureCalcs = (failedCalcs) => ({
    type: "SET_PASSWORD_CHECK_FAILURE_CALCS",
    failedCalcs
});